import { useIsProfileFieldsEnabled } from "@circle-react-shared/ProfileFields/useIsProfileFieldsEnabled";
import { reactQueryGet } from "@circle-react/helpers/backendRequestHelpers";
import { internalApi } from "@circle-react/helpers/urlHelpers";
import { useQuery } from "react-query";

import { DISPLAY_OPTION_FIELD_INPUTS } from "../shared/ProfileFields/constants";

interface ProfileFieldPage {
  name: string;
  visible: boolean;
}

interface ProfileFieldResponse {
  archived: boolean;
  field_type: string;
  id: number;
  key: string;
  label: string;
  pages?: ProfileFieldPage[];
}

const LOCATION_PROFILE_FIELD_KEY = "location-profile-field";

export const useIsMemberDirectoryMapAvailable = (): {
  isAvailable: boolean;
  isLoading: boolean;
} => {
  const isProfileFieldsEnabled = useIsProfileFieldsEnabled();

  const { data: locationField, isPending: isQueryLoading } =
    useQuery<ProfileFieldResponse>({
      queryKey: [LOCATION_PROFILE_FIELD_KEY],
      queryFn: async () =>
        reactQueryGet(internalApi.profileFields.showByKey("location")),
      retry: false,
      enabled: isProfileFieldsEnabled,
    });

  if (!isProfileFieldsEnabled) return { isAvailable: true, isLoading: false };

  if (isQueryLoading) return { isAvailable: false, isLoading: true };

  if (!locationField || locationField.archived)
    return { isAvailable: false, isLoading: false };

  const profileViewPage = locationField.pages?.find(
    page => page.name === DISPLAY_OPTION_FIELD_INPUTS.PROFILE_VIEW,
  );
  return { isAvailable: profileViewPage?.visible === true, isLoading: false };
};
